import { useState, useContext } from 'react';
import { AppContext } from '../../../sporttia/all';
import DeviceAuthDialog from '../../../components/devices/DeviceAuthDialog';
import DeviceList from '../../../components/devices/DeviceList';
import deviceConstants from '../../../components/devices/deviceConstants';
import { Device } from '../../../types/models/DeviceSpace';
import { PERMISSIONS } from '../../../lib/permissions';

type Props = {
    item: Activity;
};

type Activity = {
    id: number;
};

type DeviceAuthItem = {
    id?: number;
    dateini: string;
    dateend: string;
    timeini: string;
    timeend: string;
    weekdays: number[];
    devices?: Device[];
    [key: string]: unknown;
};

type AuthsResponse = {
    count: number;
    rows: DeviceAuthItem[];
};

type Params = {
    rows: number;
    page: number;
};

/* 'Devices' tab for the Activity page. Uses DeviceList with type=DeviceTypes.ACTIVITIES for rendering.
 *  props:
 *   Object item : the Activity object
 */
export default function ActivityDevices({ item }: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;

    const [viewAuth, setViewAuth] = useState<DeviceAuthItem | null>(null); // auth to open in the DeviceAuthDialog
    const [auths, setAuths] = useState<DeviceAuthItem[]>([]);

    function loadAuths(params: Params = { rows: 20, page: 1 }): void {
        cxt?.api('GET', `/activities/${item.id}/devices/auths`, {
            params,
            success: (response: AuthsResponse) => {
                if (response.rows) {
                    setAuths(response.rows);
                }
            },
        });
    }

    return (
        <div>
            <DeviceList
                item={item}
                type={deviceConstants.ACTIVITIES}
                auths={auths}
                loaderFunction={loadAuths}
                onCreate={(device) => setViewAuth(device as DeviceAuthItem)}
                onSelect={(device) => setViewAuth(device)}
            />
            {viewAuth && (
                <DeviceAuthDialog
                    open
                    item={viewAuth}
                    onSave={loadAuths}
                    permission={PERMISSIONS.ACTIVITY.MODIFY}
                    onClose={() => setViewAuth(null)}
                />
            )}
        </div>
    );
}
